// Module
var code = "<div class=\"protected\"\n     layout=\"column\"\n     layout-align=\"center center\">\n    <asset cls=\"colorPersonalDosimetry\" src=\"personal-dosimetry.svg\"></asset>\n    <div class=\"colorPersonalDosimetry\">Protected Page</div>\n</div>\n";
// Exports
module.exports = code;